import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ExportModule } from './export.module';

import { registerSolidIconLibraries } from './app/common/iconLibrary';
import { LOG } from './app/common/util/log';
import { DemoModule } from './demo/demo.module';
import { loglevel } from './environments/environment';
import { EXTERNAL_STYLES, GLOBAL_STYLES, externalStyles } from './styles';

import '@solid-design-system/components/dist-versioned';
import './init-highcharts';

LOG.level = loglevel;

/**
 * styles from styles.ts is only available in builds, so for the demo the style has to be read from the referenced stylesheet.
 */
function getGlobalStyles(): string {
  const globalStyleElement: Element | null = document.head.querySelector('link[href="styles.css"]');
  const globalStyleSheet: CSSStyleSheet | undefined = [...(document.styleSheets)].find(
    sheet => sheet.ownerNode === globalStyleElement
  );
  return [...globalStyleSheet!.cssRules].map(rule => rule.cssText).join('');
}

function injectExternalStyles(): void {
  for (const externalStyle of externalStyles) {
    const style: HTMLLinkElement = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = externalStyle;
    document.head.appendChild(style);
  }
}

(async function () {
  try {
    injectExternalStyles();
    registerSolidIconLibraries();
    const platform = platformBrowserDynamic([{ provide: GLOBAL_STYLES, useValue: getGlobalStyles() }, { provide: EXTERNAL_STYLES, useValue: externalStyles }]);
    await platform.bootstrapModule(ExportModule);
    await platform.bootstrapModule(DemoModule);
  } catch (err) {
    console.error(err);
  }
})();
